import cn from 'classnames'
import { useCallback, useState } from 'react'
import useFacebookSDK from 'utils/hooks/useFacebookSDK'
import useIsTelegram from 'utils/hooks/useIsTelegram'

import { FacebookIcon } from 'components/Images/Icons'
import InAppBrowserModal from 'components/InAppBrowserModal/InAppBrowserModal'

import styles from './FacebookAuth.module.scss'

interface FacebookAuthProps {
  id: string
  buttonText: string
  onAuthSuccess: (response: { providerUserToken: string }) => Promise<void>
}
const FacebookAuth = (props: FacebookAuthProps) => {
  const { id, buttonText, onAuthSuccess } = props
  const { fbLogin, isReady } = useFacebookSDK()
  const [loading, setLoading] = useState(false)
  const [showInAppModal, setShowInAppModal] = useState(false)

  const { isTelegram, openInExternalBrowser } = useIsTelegram()

  const onClick = useCallback(() => {
    if (isTelegram) {
      openInExternalBrowser()
      setShowInAppModal(true)
      return
    }

    setLoading(true)

    fbLogin()
      .then(async (response: any) => {
        if (response.authResponse.accessToken) {
          await onAuthSuccess({ providerUserToken: response.authResponse.accessToken })
        }
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => setLoading(false))
  }, [onAuthSuccess, setLoading, isTelegram, openInExternalBrowser])

  return (
    <>
      <button
        id={id}
        onClick={onClick}
        className={cn(styles.oauth_button, styles.wave, {
          [styles.waveHidden]: isReady && !loading,
        })}
        disabled={!isReady}
        color="background-70"
      >
        <FacebookIcon />

        {buttonText}
      </button>
      <InAppBrowserModal visible={showInAppModal} onClose={() => setShowInAppModal(false)} />
    </>
  )
}

export default FacebookAuth
